// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrCode_F30EW {
  height: 170px;
  width: 170px;
  align-self: center;
  margin: 30px 0 !important;
}

.key_GMO5_ {
  align-self: center;
  margin: 30px 0 !important;
}

.link_peLDU {
  display: inline;
  background-color: transparent;
  color: var( --color-linkNormal );
  font: 500 15px/20px var( --vf-Inter );
  text-decoration: none;
}

.inline_GdRC2 {
  display: inline;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-login/lib/twoFactor/methods/AuthenticatorAppConfirmation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".qrCode {\n  height: 170px;\n  width: 170px;\n  align-self: center;\n  margin: 30px 0 !important;\n}\n\n.key {\n  align-self: center;\n  margin: 30px 0 !important;\n}\n\n.link {\n  display: inline;\n  background-color: transparent;\n  color: var( --color-linkNormal );\n  font: 500 15px/20px var( --vf-Inter );\n  text-decoration: none;\n}\n\n.inline {\n  display: inline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"qrCode": `qrCode_F30EW`,
	"key": `key_GMO5_`,
	"link": `link_peLDU`,
	"inline": `inline_GdRC2`
};
export default ___CSS_LOADER_EXPORT___;
